import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { appointmentService } from '../services/api';
import SurveyForm from './SurveyForm';
import toast from 'react-hot-toast';
import { ArrowLeft } from 'lucide-react';

const SurveyFormWrapper = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const appointmentId = searchParams.get('appointment_id');

  console.log('🔍 SurveyFormWrapper - appointmentId:', appointmentId);
  console.log('🔍 SurveyFormWrapper - searchParams:', Object.fromEntries(searchParams));

  const [initialData, setInitialData] = useState(null);

  // Buscar dados do agendamento
  const { data: appointmentData, isLoading, error } = useQuery({
    queryKey: ['appointment-for-survey', appointmentId],
    queryFn: async () => {
      console.log('📡 Fetching appointment data for ID:', appointmentId);
      const result = await appointmentService.getAppointment(appointmentId);
      console.log('📡 API Response:', result);
      return result;
    },
    enabled: !!appointmentId
  });

  // Processar dados quando a query completar
  useEffect(() => {
    console.log('🔄 useEffect triggered - appointmentData:', appointmentData, 'error:', error);

    if (error) {
      console.error('❌ SurveyFormWrapper - Erro ao carregar agendamento:', error);
      toast.error('Erro ao carregar dados do agendamento');
      navigate('/levantamentos');
      return;
    }

    if (!appointmentData) {
      console.log('⏳ Waiting for appointment data...');
      return;
    }

    console.log('✅ Processing appointment data:', appointmentData);
    console.log('✅ SurveyFormWrapper - data.data:', appointmentData?.data);

    // Tentar múltiplas formas de extrair o appointment
    let appointment = null;
    if (appointmentData?.data?.appointment) {
      appointment = appointmentData.data.appointment;
    } else if (appointmentData?.appointment) {
      appointment = appointmentData.appointment;
    } else if (appointmentData?.data && typeof appointmentData.data === 'object') {
      // O dado pode estar diretamente em data.data
      appointment = appointmentData.data;
    }

    console.log('✅ SurveyFormWrapper - appointment extracted:', appointment);
    console.log('✅ SurveyFormWrapper - appointment keys:', appointment ? Object.keys(appointment) : 'N/A');

    if (appointment && typeof appointment === 'object') {
      // Preparar dados iniciais para o survey
      const prepData = {
        client_id: appointment.client_id || '',
        client_name: appointment.client_name || '',
        client_email: appointment.client_email || '',
        client_phone: appointment.client_phone || '',
        client_address: appointment.client_address || '',
        notes: `Levantamento criado a partir do agendamento #${appointment.id}\n` +
               (appointment.notes ? `Observações do agendamento: ${appointment.notes}` : ''),
        appointment_id: appointment.id,
        first_contact_id: appointment.first_contact_id || null,
        fromAppointment: true // Flag para indicar que veio de um agendamento
      };
      console.log('✅ SurveyFormWrapper - setting initialData:', prepData);
      setInitialData(prepData);
    } else {
      console.error('❌ SurveyFormWrapper - appointment is not valid object:', appointment);
    }
  }, [appointmentData, error, navigate]);

  // Debug initialData
  useEffect(() => {
    console.log('🔍 initialData changed:', initialData);
  }, [initialData]);

  const handleSuccess = () => {
    navigate('/levantamentos');
  };

  const handleClose = () => {
    navigate('/levantamentos');
  };

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-2 text-center text-gray-600">Carregando dados do agendamento...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600">Erro ao carregar agendamento</p>
          <button
            onClick={() => navigate('/levantamentos')}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Voltar para Levantamentos
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate('/levantamentos')}
          className="text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Novo Levantamento</h1>
          <p className="text-gray-600">
            Criando levantamento a partir do agendamento #{appointmentId}
          </p>
        </div>
      </div>

      {/* Formulário */}
      <SurveyForm
        survey={initialData}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </div>
  );
};

export default SurveyFormWrapper;
